module.exports = __webpack_public_path__ + "static/media/second-publish-explain.53904218.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mobile/second-publish-explain.png
// module id = 1164
// module chunks = 110